/**
 * Detect clicks on a react-select menu so the DatePicker popper does not treat
 * selecting a year/month from a portaled menu as an outside click. Year/month
 * Choices use `menuInPortal`, which renders the menu into `document.body` —
 * outside the popper's clickRef.
 */
export function isReactSelectMenuClick(target: Element): boolean {
  return Boolean(
    target.closest(
      '[role="option"], [role="listbox"], [class*="eag--choice__menu"], [class*="eag--choice__option"]'
    )
  );
}
